import { useEffect, useState } from "react";
import useIsMobile from "../../hooks/useIsMobile";

const BarLevel = (props: any) => {
  const { isMobile } = useIsMobile();
  const [level, setLevel] = useState(0);

  useEffect(() => {
    if (level === props.percentage) {
    } else if (level <= props.percentage) {
      setTimeout(() => setLevel((prevLevel) => prevLevel + 1), 10);
    }
  }, [level]);
 

  return (
    <div className="bar-wrapper" style={{width:isMobile?"100%":""}}>
      <div
        className="bar-level"
        style={{ width: `${level}%`, backgroundColor: `${props.barColor}` }}
      ></div>
    </div>
  );
};
export default BarLevel;
